<template>
<div class="not-found">
  <p>
    Could not find what you're looking for.
  </p>
  <p><router-link to="/">Home</router-link></p>
</div>
</template>

<script>
export default {
  name: 'not-found'
}
</script>

<style lang="scss">
.not-found {
  margin: auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue